module.exports = __webpack_public_path__ + "img/wifi.8642a0ae.svg";